import { makeStyles } from '@fluentui/react-components';

import { customTokens } from 'src/utils/theme';

export const useActivityProgressBoxStyles = makeStyles({
  circleBox: {
    height: '145px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  circleBoxTitle: {
    height: '37px',
    display: 'flex',
    justifyContent: 'center',
    fontSize: customTokens.fontSizeBase200,
    paddingTop: customTokens.spacingVerticalXS,
    textTransform: 'uppercase',
  },
});
